import { Polygon, Vector } from '@flatten-js/core';
import { smallestAngleBetween } from './calc-auto-breakerboard';

/**
 * Removes vertices which form consecutive, same direction edges.
 *
 * @param {Flatten.Polygon} [polygonFit=null]
 * @param {number} [angleTolerance=0.0001]
 * @returns {Flatten.Polygon}
 */
export function simplifyPolygon(polygon, angleTolerance = 0.0001) {
  const edgeVectors = [];
  for (const face of [...polygon.faces]) {
    const faceVectors = [];
    for (const edge of face) {
      faceVectors.push(new Vector(edge.shape.ps, edge.shape.pe));
    }
    faceVectors.push(faceVectors[0]);
    edgeVectors.push(faceVectors);
  }
  const simplifiedPoly = new Polygon();
  for (const [faceIndex, face] of [...polygon.faces].entries()) {
    const vertices = [];
    for (const [edgeIndex, edge] of [...face].entries()) {
      const nextEdgeVector = edgeVectors[faceIndex][edgeIndex + 1];
      const edgeVector = edgeVectors[faceIndex][edgeIndex];
      const angleBetween = smallestAngleBetween(edgeVector, nextEdgeVector);
      if (
        !edge.shape.ps.equalTo(edge.shape.pe) &&
        angleBetween > angleTolerance
      ) {
        vertices.push(edge.shape.pe);
      }
    }
    // ensure same vertices order as original
    vertices.unshift(vertices.slice(-1)[0]);
    simplifiedPoly.addFace(vertices.slice(0, -1));
  }

  return simplifiedPoly;
}
